import React from "react";
import PropTypes from "prop-types";
import { GelBand } from "../GelBand";
import { GelDragDropContext } from "../GelDragDrop.utils";
import { MIN_TRASH_HEIGHT, GEL_TYPE } from "../GelDragDrop.constants";

export function TrashCan(props) {
  const { state, onDragOver, onStripDrop, isMultiGelHolder } =
    React.useContext(GelDragDropContext);

  const TYPE = "TRASH_CAN";

  const styleHeight = Math.max(MIN_TRASH_HEIGHT, state.trashRowHeight);

  const style = { height: `${styleHeight}px` };

  const isDraggableBand = (gel) => gel.gelType === GEL_TYPE.DRAGGABLE;

  const setInnerText = (gel) => {
    if (isMultiGelHolder && isDraggableBand) return `${gel.gelId + 1}`;
    else return null;
  };

  const renderGel = (gelBand) => (
    <GelBand
      key={gelBand.gelId}
      type={TYPE}
      gelId={`${props.cellId}_${gelBand.gelId}`}
      gelType={gelBand.gelType}
      height={gelBand.height}
      opacity={gelBand.opacity}
      value={gelBand.value}
      className={`${props.className}__band`}
      selected={gelBand.selected}
    >
      {setInnerText(gelBand)}
    </GelBand>
  );

  const onDrop = (event) => {
    onStripDrop({ event, cellId: props.cellId, value: 0 });
  };

  return (
    <div
      onDragOver={onDragOver}
      onDrop={onDrop}
      className={props.className}
      style={style}
    >
      {props.cellItems.map(renderGel)}
    </div>
  );
}

TrashCan.propTypes = {
  /**
   * ClassName to be set for the cell;
   */
  className: PropTypes.string,
  /**
   * Unique Id for the cell
   */
  cellId: PropTypes.string,
  /**
   * List of GelItems to be renderd heree
   */
  cellItems: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique Id for Gel
       */
      gelId: PropTypes.number,
      /**
       * Type of Gel-Strip
       */
      gelType: PropTypes.oneOf(Object.keys(GEL_TYPE)),
      /**
       * Height value go Gel
       */
      height: PropTypes.number,
      /**
       * Opacity value of Gel
       */
      opacity: PropTypes.number,
      /**
       * Postion value of Gel
       */
      value: PropTypes.number || null,
      /**
       * Boolean to set if gel band is selected
       */
      selected: PropTypes.bool,
    })
  ),
};

TrashCan.defaultProps = {};
